import * as math from 'mathjs';
import { sanitizeExpression } from '../sanitizeExpression';

export function generatePolynomialData(equation, xMin, xMax, step) {
  const safeEq = sanitizeExpression(equation);
  const x = [], y = [];
  let fn;
  try { fn = math.compile(safeEq); } catch { return []; }
  for (let xi = xMin; xi <= xMax; xi += step) {
    let val;
    try { val = fn.evaluate({ x: xi }); }
    catch { val = NaN; }
    x.push(xi);
    y.push(typeof val === 'number' && Number.isFinite(val) ? val : NaN);
  }
  return [{ x, y }];
}
